import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiPlus, HiPencil, HiTrash, HiSearch } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function BusinessTypeTable() {
  const [businessTypes, setBusinessTypes] = useState([]);
  const [businessTypeName, setBusinessTypeName] = useState("");
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchBusinessTypes();
  }, []);

  const fetchBusinessTypes = async () => {
    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("No authentication token found");
        return;
      }

      const response = await axios.get("http://localhost:5890/Bussinesstype", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setBusinessTypes(response.data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Session expired. Please login again.");
        } else {
          toast.error(`Failed to load business types: ${error.response.data.error || error.message}`);
        }
      } else {
        toast.error("Failed to load business types");
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setBusinessTypeName("");
    setEditId(null);
  };

  const handleSaveBusinessType = async () => {
    if (!businessTypeName.trim()) {
      toast.warn("Please enter a business type");
      return;
    }

    setIsSaving(true);
    const token = sessionStorage.getItem("token");
    
    if (!token) {
      toast.error("No authentication token found");
      setIsSaving(false);
      return;
    }

    try {
      if (editId) {
        await axios.put(
          `http://localhost:5890/Bussinesstype/${editId}`,
          { name: businessTypeName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        toast.success("Business type updated successfully");
      } else {
        await axios.post(
          "http://localhost:5890/Bussinesstype",
          { name: businessTypeName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        toast.success("Business type added successfully");
      }

      document.getElementById("closeModalBtn").click();
      resetForm();
      fetchBusinessTypes();
    } catch (error) {
      console.error(error);
      if (error.response) {
        toast.error(`Error: ${error.response.data.error || error.message}`);
      } else {
        toast.error("Failed to save business type");
      }
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this business type?")) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          toast.error("No authentication token found");
          return;
        }

        await axios.delete(`http://localhost:5890/Bussinesstype/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Business type deleted successfully");
        fetchBusinessTypes();
      } catch (error) {
        if (error.response) {
          toast.error(`Error: ${error.response.data.error || error.message}`);
        } else {
          toast.error("Failed to delete business type");
        }
      }
    }
  };

  const filteredTypes = businessTypes.filter((type) =>
    type.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container my-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="bg-white shadow rounded-4 p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold text-dark m-0">Business Types</h3>
          <button
            className="btn btn-success d-flex align-items-center gap-2"
            data-bs-toggle="modal"
            data-bs-target="#businessModal"
            onClick={resetForm}
          >
            <HiPlus size={18} /> Add Business Type
          </button>
        </div>

        <div className="mb-3 position-relative">
          <div className="position-absolute start-0 top-0 h-100 d-flex align-items-center ps-3 text-muted">
            <HiSearch />
          </div>
          <input
            type="text"
            className="form-control ps-5"
            placeholder="Search business types..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-responsive rounded-3 border">
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th className="ps-4">#</th>
                  <th>Business Type</th>
                  <th className="text-end pe-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTypes.length > 0 ? (
                  filteredTypes.map((type, index) => (
                    <tr key={type.id} className="border-top">
                      <td className="ps-4 fw-semibold">{index + 1}</td>
                      <td>
                        <span className="d-inline-block text-truncate" style={{maxWidth: '300px'}}>
                          {type.name}
                        </span>
                      </td>
                      <td className="text-end pe-4">
                        <div className="d-flex gap-2 justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary rounded-circle p-2"
                            onClick={() => {
                              setEditId(type.id);
                              setBusinessTypeName(type.name);
                              new bootstrap.Modal(
                                document.getElementById("businessModal")
                              ).show();
                            }}
                          >
                            <HiPencil size={16} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger rounded-circle p-2"
                            onClick={() => handleDelete(type.id)}
                          >
                            <HiTrash size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center text-muted py-5 fst-italic">
                      {search ? "No matching business types found" : "No business types found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="businessModal"
        tabIndex="-1"
        aria-labelledby="businessModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title fw-bold" id="businessModalLabel">
                {editId ? "Edit Business Type" : "Add Business Type"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetForm}
              ></button>
            </div>
            <div className="modal-body py-4">
              <div className="mb-3">
                <label className="form-label fw-semibold mb-2">
                  Business Type Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control border-2 py-2"
                  placeholder="e.g. Retail, Restaurant, IT Services"
                  value={businessTypeName}
                  onChange={(e) => setBusinessTypeName(e.target.value)}
                  autoFocus
                />
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                data-bs-dismiss="modal"
                onClick={resetForm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary px-4"
                onClick={handleSaveBusinessType}
                disabled={isSaving || !businessTypeName.trim()}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {editId ? "Updating..." : "Adding..."}
                  </>
                ) : editId ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}